__turbopack_context__.v({
  "alert": "InscriptionCard-module__hHQ2CW__alert",
  "body": "InscriptionCard-module__hHQ2CW__body",
  "content": "InscriptionCard-module__hHQ2CW__content",
  "contentWrapper": "InscriptionCard-module__hHQ2CW__contentWrapper",
  "footer": "InscriptionCard-module__hHQ2CW__footer",
  "link": "InscriptionCard-module__hHQ2CW__link",
  "pfpButton": "InscriptionCard-module__hHQ2CW__pfpButton",
  "root": "InscriptionCard-module__hHQ2CW__root",
  "row": "InscriptionCard-module__hHQ2CW__row",
  "satsWarning": "InscriptionCard-module__hHQ2CW__satsWarning",
  "subtitle": "InscriptionCard-module__hHQ2CW__subtitle",
  "warningLabel": "InscriptionCard-module__hHQ2CW__warningLabel",
});
